import _ from 'lodash';
import React, { FC } from 'react';
import * as Styled from './styled';

interface Props<T> {
	children: Array<T> | T;
}

const GridRow: FC<Props<JSX.Element>> = props => {
	const { children } = props;
	if (!_.isArray(children)) {
		return (
			<Styled.Wrapper>
				<Styled.Row>
					<Styled.Column md="4" sm="12">
						{children}
					</Styled.Column>
				</Styled.Row>
			</Styled.Wrapper>
		);
	} else {
		return (
			<Styled.Wrapper>
				<Styled.Row>
					{_.map(children, (child, i) => (
						<Styled.Column md="4" sm="12" key={i}>
							{child}
						</Styled.Column>
					))}
				</Styled.Row>
			</Styled.Wrapper>
		);
	}
};

export default GridRow;
